module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavy.a2d1b35.eot";